import * as moment from 'moment';

import { TicketFilter } from '@app/services/tickets.service';
import { TicketCompletedStatusType } from '@shared/enums/ticket-status-type';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { RestUpdateInspectionTicket } from '@shared/interfaces/ticket.interface';
import { RestTicketModel } from '@shared/interfaces/turnover.interface';
import { getFilterDateRange } from '@template/utils/filter';

export namespace TicketListConstants {
  export enum TimeFrame {
    Week = 1,
    Month,
    Month_3,
    Month_6,
    Year,
    AllTime,
    Custom,
    ThisWeek,
    NextTwoWeeks,
    ThisMonth,
    ThisQuarter,
    ThisYear,
  }

  export const timeFrames = [
    { value: TimeFrame.Week, label: 'past 7 days' },
    { value: TimeFrame.Month, label: 'past 30 days' },
    { value: TimeFrame.Month_3, label: 'past 3 months' },
    { value: TimeFrame.Month_6, label: 'past 6 months' },
    { value: TimeFrame.Year, label: 'past year' },
    { value: TimeFrame.ThisWeek, label: 'this week' },
    { value: TimeFrame.NextTwoWeeks, label: 'next two weeks' },
    { value: TimeFrame.ThisMonth, label: 'this month' },
    { value: TimeFrame.ThisQuarter, label: 'this quarter' },
    { value: TimeFrame.ThisYear, label: 'this year' },
    { value: TimeFrame.AllTime, label: 'all time' },
    { value: TimeFrame.Custom, label: 'custom' },
  ];
}

export const labelConfig: IRadioButtonOption<number>[] = [
  {
    label: 'Service Summary Report',
    value: -1,
    groupValue: null,
  },
];

export function getTicketId(ticket?: RestTicketModel | RestUpdateInspectionTicket | undefined): string {
  if (!ticket) return '';

  const pmsTicketText = ticket?.pmsWorkOrderNumber ?? ticket?.pmsWorkOrderId;

  return pmsTicketText ? pmsTicketText : `PU${ticket.id}`;
}

export const getServerPartFilter = (
  filter: { [key: string]: any },
  filterParams: { [key: string]: any },
  currentDate: Date,
  selectedPropertyIds: number[]
): TicketFilter => {
  const filterData: Partial<TicketFilter> = {
    portfolioId: filter.portfolioId,
    includeCompleted: !filter.isCompleted ? null : filter.isCompleted !== TicketCompletedStatusType.IsCompleted,
    propertyIds: selectedPropertyIds?.length ? selectedPropertyIds : null,
    periodDateSearchFields: filter.periodDateSearchFields,
  };

  if (filter.timeframe === TicketListConstants.TimeFrame.Custom) {
    if (filter.customStartDate) filterData.startDate = moment(filter.customStartDate).format('YYYY-MM-DD');
    if (filter.customEndDate) filterData.endDate = moment(filter.customEndDate).format('YYYY-MM-DD');
  } else {
    const { startDate, endDate } = getFilterDateRange(currentDate, filter, true, true) || {};
    filterData.startDate = (startDate as string) || null;
    filterData.endDate = (endDate as string) || null;
  }

  if (filter.serviceByStatusFilter) filterData.serviceByStatusFilter = filter.serviceByStatusFilter;

  if (filterParams && Object.keys(filterParams)?.length) {
    if (filterParams.periodDateSearchFields) filterData.periodDateSearchFields = filterParams.periodDateSearchFields;

    if (filterParams.collectionId) filterData.collectionIds = filterParams.collectionId;

    if (filterParams.boardId) filterData.boardId = filterParams.boardId;

    if (filterParams.unitTypeId) filterData.unitType = filterParams.unitTypeId;

    if (filterParams.ticketCategoryId) filterData.ticketCategoryId = filterParams.ticketCategoryId;

    if (filterParams.reportingCategoryIds) {
      filterData.ticketReportingCategoryId = filterParams.reportingCategoryIds;
    }

    if (filterParams.topicId) filterData.ticketTopicId = filterParams.topicId;

    if (filterParams.ticketTypeId !== undefined) filterData.ticketSummaryType = filterParams.ticketTypeId;
  }

  // const filterPayload: SummaryStatsV2Filter[] = [];

  // if (filter?.reportingCategoryIds?.length > 0) {
  //   filterPayload.push({
  //     builtIn: ServiceSummaryGroupV2Type.ReportingCategory,
  //     values: filter.reportingCategoryIds.join(','),
  //   });
  // }

  // filterData.filters = JSON.stringify(filterPayload);

  return filterData;
};

export type ServiceFilterPanel = {
  field: string;
  text: string;
  value: string | number;
  color?: number;
  isArray: boolean;
  selector: string;
};

export const filterPanelNotEmpty = (filterPanels: { [key: string]: any } | null): boolean => {
  if (!filterPanels) return false;

  return Object.values(filterPanels).some(value => {
    if (Array.isArray(value)) return value?.length > 0;
    return value !== null && value !== undefined && value !== '';
  });
};

export const AllTimeStartingPeriod = '2022-01-01';
